import { Err } from "../../../error";
import { ISite } from "../../../apiFacades/csu/site";

export interface ISiteKey {
  customerId: string;
  siteId: string;
}

export interface ISiteState {
  data: ISite;
  error: Err;
  pending: boolean;
}

export const SITE_FETCH_REQUESTED = "SITE_FETCH_REQUESTED";
export const SITE_FETCH_FULFILLED = "SITE_FETCH_FULFILLED";
export const putSiteFetchFulfilled = (site: ISite) => ({
  type: SITE_FETCH_FULFILLED,
  payload: site,
});
export const SITE_FETCH_REJECTED = "SITE_FETCH_REJECTED";
export const SITE_WAS_RESET = "SITE_WAS_RESET";

export const requestSiteFetch = (
  customerId: string,
  siteId: string,
): IAction<ISiteKey> => ({
  payload: { customerId, siteId },
  type: SITE_FETCH_REQUESTED,
});

export const resetSite = (): IAction<void> => ({
  payload: null,
  type: SITE_WAS_RESET,
});

const defaultState: ISiteState = { data: null, error: null, pending: false };

export default function reducer(
  state: ISiteState = defaultState,
  action: IAction<any>,
): ISiteState {
  switch (action.type) {
    case SITE_FETCH_REQUESTED:
      return {
        ...defaultState,
        pending: true,
      };
    case SITE_FETCH_FULFILLED:
      return {
        ...defaultState,
        data: action.payload,
      };
    case SITE_FETCH_REJECTED:
      return {
        ...defaultState,
        error: action.payload,
      };
    case SITE_WAS_RESET:
      return {
        ...defaultState,
      };
    default:
      return state;
  }
} // END reducer

export const getSiteSrs = (siteState: ISiteState) =>
  siteState.data ? siteState.data.srs : null;

export const isSiteImperial = (siteState: ISiteState) =>
  siteState.data.isImperial;
